import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/informes-seguridad")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/informes-seguridad", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia/informes-seguridad", replace: true });
  },
});
